module.exports = "dist/brasao-casa-militar.png?9ecade06941ad1267df44f8e934beaef";